import React, { useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { AlertMessage } from 'src/screens/Partners/Service/components';
import firebase from '../config/firebase'; // firebase
import { makeStyles } from '@mui/styles';
import { connect } from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import { CircularProgress } from '@mui/material';
import CustomDialog from 'src/components/schooladmit-res-comp/CustomDialog';
import { remove_user, save_partnerSession } from '../store/action';
import AlertIcon from 'src/assets/images/alert.png';

const ColorCircularProgress = withStyles({
  root: {
    color: '#fff',
    width:'20px !important',
    height:'20px !important'
  },
})(CircularProgress);

const useStyles = makeStyles(theme => ({
mobileViewDialog:{
  borderRadius:'28px',
  '&.MuiDialog-paper':{
      [theme.breakpoints.down('sm')]: {
          margin:'32px 5px !important',
          width:'calc(100% - 10px) !important'
      }
  }
},

dialogContentCls:{
  padding:'8px 24px !important',
  [theme.breakpoints.down('sm')]: {
      padding:'8px 12px !important'
  }
},

  dialogActionCls:{
    display:'none'
  },

  dialogDiv:{
    width: 'calc(100% - 10px)',
    display: 'flex',
    padding: '20px 5px !important',
    flexDirection: 'column',
    position:'relative',
    backgroundColor:'#fff !important'
},

rowDiv:{
  display:'flex',
  flexDirection:'row',
},

colDiv:{
  display:'flex',
  flexDirection:'column'
},

imgContainer:{
  width:'150px',
  height:'150px',

  '& img':{
    width:'100%',
    height:'100%',
  }
},

spanTxt:{
  fontSize:'16px',
  fontWeight:500
},

btnStyle:{
  outline:'none',
  border:'none',
  cursor:'pointer',
  backgroundColor:'#36ABEF',
  color:'#fff',
  minWidth:'150px',
  width:'fit-content',
  padding:'0px 5px',
  height:'40px',
  textAlign:'center',
  borderRadius:'5px',
  fontSize:'14px',
  fontWeight:500,
  transition:'0.4s all ease',
  display:'flex',
  flexDirection:'column',
  alignItems:'center',
  justifyContent:'center',

  '&:hover':{
    opacity:0.7
  },

  '&:focus':{
    opacity:0.7
  }
}
}));

function Session(props) {
  const isMounted = React.useRef(null);
  const timerRef = useRef(null);
  const userSessionTimeout = useRef(null); // Ref to hold timeout ID
  const [redirect, setRedirect] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [countdown, setCountdown] = useState(60);
  const classes = useStyles();
  const {user, t, i18n, savePartnerSession, sessionDuration } = props;

  const isRTL = i18n.translator.language;
  const ar = "'Cairo', sans-serif";
  const en = "'Poppins', sans-serif";
  const fontFamily = isRTL === 'ar' ? ar : en;

    useEffect(() => {
      return () => {
        isMounted.current = false;
        if (userSessionTimeout.current) {
          clearTimeout(userSessionTimeout.current);
        };
        setShowDialog(false);
        setRedirect(false);
        setLoading(false);
      };
    }, [user?.id]);

  useEffect(() => {
    isMounted.current = true;
    checkAuth();
    return () => {
      isMounted.current = false;
      if (userSessionTimeout.current) {
        clearTimeout(userSessionTimeout.current);
      };
      setShowDialog(false);
      setRedirect(false);
      setLoading(false);
    };
  }, []);

  const checkAuth = async (extendTime) => {
    const user = firebase.auth().currentUser; // Get the current user
    if (user) {
      const idTokenResult = await user.getIdTokenResult();
      const authTime = idTokenResult.claims.auth_time * 1000;
      const sessionDurationInMilliseconds = extendTime ? (extendTime * 60 * 60 * 1000) : ((sessionDuration || 4) * 60 * 60 * 1000);
      if(sessionDuration && extendTime) {
        savePartnerSession(extendTime);
      } 
      else if(!sessionDuration){
        savePartnerSession(4);
      }
      // 4 * 60 * 60 * 1000; // 4 hours
      const expirationInMilliseconds = sessionDurationInMilliseconds - (Date.now() - authTime);
      console.log('expirationInMilliseconds',expirationInMilliseconds)
      console.log('authTime',authTime)
      console.log('sessionDurationInMilliseconds',sessionDurationInMilliseconds,idTokenResult)

      // Clear previous timeout if it exists
      if (userSessionTimeout.current) {
        clearTimeout(userSessionTimeout.current);
      }

      // Set new timeout if there's still time left
      if (expirationInMilliseconds > 0) {
        userSessionTimeout.current = setTimeout(() => {
          setShowDialog(true);
        }, expirationInMilliseconds);
      } 
      else {
      //   // If expired, immediately show the dialog
        setShowDialog(true);
      }
    } else {
      // Clear the timeout if the user is logged out
      if (userSessionTimeout.current) {
        clearTimeout(userSessionTimeout.current);
        userSessionTimeout.current = null;
      }
    }
  };

  useEffect(() => {
    if (showDialog) {
      // Reset countdown to 60 seconds when timer starts
      setCountdown(60);
      
      // Start a countdown timer that updates every second
      timerRef.current = setInterval(() => {
        setCountdown(prevCountdown => {
          if (prevCountdown <= 1) {
            clearInterval(timerRef.current);
            setShowDialog(false)
            // setTimeout(()=> {
            logoutUser();
            // },3000);
            return 0; // Prevent going negative
          }
          return prevCountdown - 1; // Decrease countdown
        });
      }, 1000); // 1000 milliseconds = 1 second
    }

    // Cleanup: clear the interval if `isTimerActive` changes or the component unmounts
    return () => clearInterval(timerRef.current);
  }, [showDialog]);

  const logoutUser = async () => {
    firebase.auth().signOut().then(() => {
    })
    props.logout_user();

    setRedirect(true);
    setLoading(false);
  };

  // const handleStayLoggedIn = async () => {
  //   // Reset the timer and dialog when the user chooses to stay logged in

  //   const user = firebase.auth().currentUser; // Get the current user

  //   const session = sessionDuration ? sessionDuration+1 : 1;

  //   if (user) {
  //     const idTokenResult = await user.getIdTokenResult();
  //     const authTime = idTokenResult.claims.auth_time * 1000;
  //     const sessionDurationInMilliseconds = (session * 60 * 1000);
      
  //   }

  //   setShowDialog(false);
  //   checkAuth(sessionDuration ? sessionDuration+1 : 1); // Re-run checkAuth to reset the session timer
  // };

  const handleStayLoggedIn = async () => {
    // Reset the timer and dialog when the user chooses to stay logged in
    setLoading(true);
    const user = firebase.auth().currentUser; // Get the current user
    if (!user) return;
  
    let session = sessionDuration ? sessionDuration + 4 : 4;
  
    const idTokenResult = await user.getIdTokenResult();
    const authTime = idTokenResult.claims.auth_time * 1000;
  
    const waitForPositiveSession = () => {
      const sessionDurationInMilliseconds = session * 60 * 60 * 1000;
      const expirationInMilliseconds = sessionDurationInMilliseconds - (Date.now() - authTime);
  
      console.log("Checking expirationInMilliseconds:", expirationInMilliseconds);
  
      if (expirationInMilliseconds > 0) {
        // When the session is valid, call checkAuth
        setShowDialog(false);
        checkAuth(session);
        setLoading(false);
      } else {
        // Increment the session and retry after 1 second
        session += 8;
        setTimeout(waitForPositiveSession, 1000);
      }
    };
  
    // Start the loop
    waitForPositiveSession();
  };


  const onCloseDelDialog = (_,reason) => {
    if(reason !== 'backdrop') {
      setShowDialog(false);
    }
  };

  if (redirect) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <CustomDialog
        onClose={()=> onCloseDelDialog('','backdrop')}
        open={showDialog} 
        title={''}
        maxWidth={'sm'}
        customClasses={{paper:classes.mobileViewDialog}}
        contentCustomCls={classes.dialogContentCls}
        actionCustomCls={classes.dialogActionCls}
      >
        <div className={classes.dialogDiv} style={{fontFamily}}>
            <div className={classes.rowDiv} style={{alignItems:'center'}}>
                <div className={classes.imgContainer}>
                  <img src={AlertIcon} alt='alert' />
                </div>
                <div className={classes.colDiv}>
                  <span className={classes.spanTxt}>{t('partner.dashboard.sessionTitle')}</span>
                  <span className={classes.spanTxt}>{t('partner.dashboard.sessionTitle2',{seconds:countdown})}</span>
                </div>
            </div>
            <div className={classes.rowDiv} style={{alignItems:'center',alignSelf:'flex-end'}}>
              <button className={classes.btnStyle} onClick={logoutUser} style={{fontFamily,backgroundColor:'#DDE1E7',color:'#000',...(isRTL === 'ar' ? {marginLeft:'20px'} : {marginRight:'20px'})}}>{t && t('parentDashboard.logout')}</button>
              <button className={classes.btnStyle} style={{fontFamily,cursor:loading ? 'not-allowed' : 'pointer'}} onClick={!loading ?handleStayLoggedIn : null}>{loading ?<ColorCircularProgress /> : t && t('partner.dashboard.continueSession')}</button>
            </div>
        </div>
      </CustomDialog>
      <AlertMessage {...{alertType:'warning',message:'Sorry, your session has expired',snackOpen:open,closeAlert:()=> setOpen(false)}} />
    </>
  );
}

const mapStateToProps = state => {
  return {
      user: state.user,
      company: state.company,
      sessionDuration: state.sessionDuration
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout_user : () => dispatch(remove_user()),
    savePartnerSession: (data) => dispatch(save_partnerSession(data))
  };
};

export default withTranslation('common')(connect(mapStateToProps, mapDispatchToProps)(Session));